import { Theme } from '@emotion/react';
import { makeStyles } from '@mui/styles';
import { Colors } from '../color/Colors';

export const useButtonStyles = makeStyles((theme: Theme) => ({
  button: {
    width: 'fit-content',
    height: 'fit-content',
    marginRight: '10px',
  },
}));
